import {
  GET_STUDY,
  GET_GEOM,
  GET_ANALYSES,
  ADD_ANALYSIS_GEOM,
  REMOVE_ANALYSIS_GEOM,
  GET_DOWNLOADS,
  ERROR_DETAILS,
  SORT_ANALYSES_BY_DATE,
  SORT_ANALYSES_BY_ALPHA,
  CLEAR_DETAILS,
  SORT_ANALYSES_BY_ECONOMIC_LOSSES_LOW_TO_HIGH,
  SORT_ANALYSES_BY_ECONOMIC_LOSSES_HIGH_TO_LOW,
} from "./types";
import { parseSearch, config } from "./helpers";
import axios from "axios";
import handleGA, { gaEvents } from "../googleAnalytics";
const api = process.env.REACT_APP_API;

const getStudy = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${api}results/${id}`, config);
    const data = res.data[0].fields;
    data.id = id;
    handleGA(gaEvents.VIEW_EVENT, `id: ${data.id}; name: ${data.name}`);

    dispatch({
      type: GET_STUDY,
      payload: data,
    });
  } catch (error) {
    const msg = { msg: "Unable to get study", error: error.message };
    console.error(msg);
  }
};

const getGeom = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${api}results/${id}/geom`, config);
    dispatch({
      type: GET_GEOM,
      payload: JSON.parse(res.data[0].geom),
    });
  } catch (error) {
    const msg = { msg: "Unable to get geometry", error: error.message };
    console.error(msg);
  }
};

const getAnalyses = (id) => async (dispatch) => {
  try {
    const lossesConversation = {
      thousand: 1000,
      million: 1000000,
      billion: 1000000000,
      trillion: 1000000000000,
    };
    const res = await axios.get(`${api}results/${id}/analyses`, config);
    const resDataWithLosses = res.data.map((d) =>
      d.losses && d.lossesUnit
        ? { ...d, totalLosses: d.losses * lossesConversation[d.lossesUnit] }
        : d
    );
    dispatch({
      type: GET_ANALYSES,
      payload: resDataWithLosses,
    });
  } catch (error) {
    const msg = { msg: "Unable to get analyses", error: error.message };
    console.error(msg);
  }
};

const getAnalysisGeom = async (id) => {
  try {
    const res = await axios.get(`${api}analyses/${id}/geom`, config);
    return JSON.parse(res.data[0].geom);
  } catch (error) {
    const msg = { msg: "Unable to get analysis geom", error: error.message };
    console.error(msg);
  }
};

const getDownloads = (id) => async (dispatch, getState) => {
  try {
    const { analyses } = getState().details;
    analyses.forEach(async (analysis) => {
      const res = await axios.get(
        `${api}analyses/${analysis.id}/downloads`,
        config
      );
      const payload = {
        analysis_id: analysis.id,
        downloads: res.data,
      };
      dispatch({
        type: GET_DOWNLOADS,
        payload: payload,
      });
    });
  } catch (error) {
    const msg = { msg: "Unable to get downloads", error: error.message };
    console.error(msg);
  }
};

export const setDetails = () => async (dispatch) => {
  try {
    const searchParams = parseSearch();
    const { id, type } = searchParams;

    dispatch(getStudy(id));
    dispatch(getGeom(id));
    // getAnalyses must return promise before calling getDownloads
    await dispatch(getAnalyses(id));
    dispatch(getDownloads(id));
  } catch (error) {
    const msg = { msg: "Unable to set details", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_DETAILS,
      payload: msg,
    });
  }
};

export const setGeom = () => async (dispatch) => {
  const searchParams = parseSearch();
  const { id } = searchParams;
  try {
    const geom = await getGeom(id);
    dispatch({
      type: GET_GEOM,
      payload: geom,
    });
  } catch (error) {
    const msg = { msg: "Unable to set geometry", error: error.message };
    console.error(msg);
  }
};

export const setAnalysisGeom = (id) => async (dispatch, getState) => {
  try {
    const {
      details: { analysis_geoms },
    } = getState();
    const idInGeoms = analysis_geoms.some((geom) => geom.id === id);
    if (idInGeoms) {
      dispatch({
        type: REMOVE_ANALYSIS_GEOM,
        payload: { id, geom: null },
      });
    } else {
      const geom = await getAnalysisGeom(id);
      dispatch({
        type: ADD_ANALYSIS_GEOM,
        payload: { id, geom },
      });
    }
  } catch (error) {
    const msg = { msg: "Unable to set analysis geom", error: error.message };
    console.error(msg);
  }
};

export const setStudy = () => async (dispatch) => {
  const searchParams = parseSearch();
  const { id } = searchParams;
  try {
    const res = await axios.get(`${api}results/${id}`, config);
    const data = res.data[0].fields;
    dispatch({
      type: GET_STUDY,
      payload: data,
    });
  } catch (error) {
    const msg = { msg: "Unable to set study", error: error.message };
    console.error(msg);
  }
};

export const sortAnalysesByDate = (order) => async (dispatch) => {
  try {
    dispatch({
      type: SORT_ANALYSES_BY_DATE,
      payload: order,
    });
  } catch (error) {
    const msg = { msg: "Unable to get sort analyses", error: error.message };
    console.error(msg);
  }
};

export const sortAnalysesByAlpha = (order) => async (dispatch) => {
  try {
    dispatch({
      type: SORT_ANALYSES_BY_ALPHA,
      payload: order,
    });
  } catch (error) {
    const msg = { msg: "Unable to get sort analyses", error: error.message };
    console.error(msg);
  }
};

export const sortAnalysesByEconomicLosses = (order) => async (dispatch) => {
  try {
    order === "losses-low-high" &&
      dispatch({
        type: SORT_ANALYSES_BY_ECONOMIC_LOSSES_LOW_TO_HIGH,
        payload: order,
      });

    order === "losses-high-low" &&
      dispatch({
        type: SORT_ANALYSES_BY_ECONOMIC_LOSSES_HIGH_TO_LOW,
        payload: order,
      });
  } catch (error) {
    const msg = { msg: "Unable to get sort analyses", error: error.message };
    console.error(msg);
  }
};

export const clearDetails = () => async (dispatch) => {
  try {
    dispatch({
      type: CLEAR_DETAILS,
      payload: null,
    });
  } catch (error) {
    const msg = { msg: "Unable to clear details", error: error.message };
    console.error(msg);
  }
};
